/**
 * widgets/registry.codable.tsx — Codable widgety.
 *
 * `codable.projects` — seznam projektů (hlavní UI, node-aware přes callWidgetTool).
 * `codable.project-members` — správa vlastníků projektů (entity_group members
 *   `codable-project:<slug>:{read,write}`). Grant/revoke přes identity tooly.
 * `codable.llm-allowlist` — admin allow-list LLM profilů per tenant / per projekt.
 * Vše multilingual (useTranslation) a widget-first (Filip 2026-07-24).
 */
import { BookOpen, FolderKanban, GitBranch, Settings } from 'lucide-react';
import type { WidgetSpec } from './types';
import { CodableProjectsWidget } from '../pages/modules/codable/CodableList';
import { CodableLibraryWidget } from '../pages/modules/codable/CodableLibrary';
import { CodableSettingsHub } from '../pages/modules/codable/CodableSettingsHub';
import { CodableWorkspaceWorkWidget } from '../pages/modules/codable/CodableWorkspaceWorkWidget';

export const CODABLE_WIDGETS: WidgetSpec[] = [
  {
    id: 'codable.projects',
    title: 'Projects',
    module: 'codable',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: FolderKanban,
    component: CodableProjectsWidget,
  },
  {
    id: 'codable.library',
    title: 'Library',
    module: 'codable',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: BookOpen,
    component: CodableLibraryWidget,
  },
  {
    id: 'codable.settings-hub',
    title: 'Settings',
    module: 'codable',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: Settings,
    component: CodableSettingsHub,
  },
  {
    id: 'codable.workspace-work',
    title: 'Build worker & parked work',
    module: 'codable',
    kind: 'custom',
    format: 'lg',
    formats: ['md', 'lg'],
    icon: GitBranch,
    component: CodableWorkspaceWorkWidget,
  },
];
